module.exports = __webpack_public_path__ + "promo.3c46e026475f528c2de4.gif";